<script>

export default {
  props: {
    value: {
      
    },
    options: {
      type: Array,
      required: true
    },
    optionLabel: {
      type: String,
      default: 'label' 
    },
    optionValue: {
      type: String,
      default: 'value'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  mounted() {
    if(this.value) {
      this.$el.value = this.value !== Object(this.value) ? this.value : this.value[this.optionValue]
    }
  },
  computed: {
    elementIsPrimitive() {
      return this.options[0] !== Object(this.options[0])
    },
    optionsMapped() {
      if( this.elementIsPrimitive ) {
        return this.options.map( option => ({ [this.optionLabel]: option }))
      } else {
        return this.options
      }
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.onChange
      }
    }
  },
  methods: {
    onChange(event) {
      this.$emit('input', event.target.value )
    }
  }
}

</script>

<template>
  <select v-bind="$attrs" v-on="listeners" class="select">
    <option :value="null">{{ placeholder }}</option>
    <option v-for="(option, index) in options" :key="index" :value=" optionValue ? option[optionValue] : option[optionLabel]">
      {{ option[optionLabel] }}
    </option>
  </select>
</template>

<style scoped>
.select {
  display: block;
  width: 100%;
  padding: 6px 6px;
  font-size: 14px;
  border-radius: 3px;
  background-color: #18191c;
  color: #D5D6D7;
  outline: none;
  border: none;
  /* box-shadow: 0 0 0 1px #1D375F; */
  transition: box-shadow .3s;
}

.select:focus {
  box-shadow: 0 0 0 1px #006eff;
}


body:not(.dark) .select {
  background-color: #f8f8f8;
  box-shadow: 0 0 0 1px #cacaca;
}

body:not(.dark) .select:focus {
  box-shadow: 0 0 0 1px #232c7c;
}

</style>